require('lessRoot/coupons.less');

Blain.Coupons = {
	init: function() {
		const $details = $("#coupons .show-fine-print");
		if (!$details.length) return;

		$details.on("click", function(e) {
			e.preventDefault();
			const finePrint = $(this).parents(".coupon-copy").find(".coupon-fine-print").html();
			$.modalMsg({
				message: finePrint,
				width: "medium"
			});
		});
	}
};

(function($) {
	$(document).ready(function() {
		Blain.Coupons.init();
	});
})(jQuery);